import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 20,
  },
  inputGroup: {
    width: '100%',
    marginBottom: 15,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    marginBottom: 6,
    color: '#000',
  },
  inputBox: {
    backgroundColor: '#fff',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#ccc',
    width: '100%',
  },
  input: {
    color: '#000',
    width: '100%',
    paddingLeft: 10,
  },
  errorText: {
    fontSize: 12,
    color: '#F00',
    textAlign: 'left',
  },
  buttonContainer: {
    width: '100%',
    marginTop: 10,
  },
  button: {
    backgroundColor: '#0F6657',
    borderRadius: 4,
    paddingVertical: 12,
    width: '100%',
  },
  buttonOutline: {
    borderColor: '#0F6657',
    borderWidth: 2,
    borderRadius: 4,
    paddingVertical: 12,
    width: '100%',
  },
  buttonTitle: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
  },
});
